import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { AmountRateResponseDTO, ExchangeCalculateRequestDTO } from '../../domain/ExchangeCalculate/entities';
import { Currency } from '../../domain/Currency/entities';

export type ExchangeCalculateState = {
  // currencies
  currenciesData: Nullable<Currency[]>;
  isLoadingCurrencies: boolean;
  currenciesError?: AxiosError<APIGatewayResponse<Currency[]>, any>;
  // exchange calculator
  exchangeCalculateRequest: Nullable<ExchangeCalculateRequestDTO>;
  isFirstExchangeCalculation: boolean;
  amountRateData: Nullable<AmountRateResponseDTO>;
  isLoadingAmountRate: boolean;
  amountRateError?: AxiosError<APIGatewayResponse<AmountRateResponseDTO>, any>;
  onExchangeCalculate: (
    fromCurrencyId: number,
    toCurrencyId: number,
    amount: number,
    isFirstExchangeCalculation?: boolean,
  ) => void;
};

export enum ExchangeCalculateContextActionTypes {
  SetExchangeCalculateRequest = '@@ExchangeCalculate/setExchangeCalculateRequest',
}
